module.exports = __webpack_public_path__ + "static/media/Avenir-Heavy.b29ab4f5.woff2";